import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["as"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.bold.js";
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { getPropFilter, getPropNamesFromPropDefinition, getDimmedTextColor } from 'utils/ui';
import { positionProps, positionPropsDef, marginProps, marginPropsDef } from 'styles/styleProps';
import ButtonCore from 'components/ButtonCore';
function getLinkColor(_ref) {
  var stealthy = _ref.stealthy,
    disabled = _ref.disabled,
    isDisabled = _ref.isDisabled,
    theme = _ref.theme;
  if (disabled || isDisabled) {
    return getDimmedTextColor(theme);
  } else if (stealthy) {
    return 'inherit';
  } else {
    return theme.links;
  }
}
var stylePropNames = getPropNamesFromPropDefinition([].concat(_toConsumableArray(positionPropsDef), _toConsumableArray(marginPropsDef)));
var textLinkProps = ['bold', 'stealthy', 'fontSize'];
var shouldForwardProp = getPropFilter([].concat(textLinkProps, _toConsumableArray(stylePropNames)));
var textLinkStyles = css(["", " ", " text-align:inherit;text-decoration:none;transition:color 0.25s ease-in;color:", ";&:not(.is-disabled):hover,&:not(.is-disabled):focus,&:not(.is-disabled):active{", " text-decoration:underline;transition-timing-function:ease-out;}"], function (p) {
  return p.fontSize && "\n\t\tfont-size: ".concat(p.theme.globals.typeScale[p.fontSize] || p.fontSize, ";\n\t");
}, function (p) {
  return p.bold && "\n\t\tfont-weight: bold;\n\t";
}, getLinkColor, function (p) {
  return p.stealthy && "\n\t\t\tcolor: ".concat(p.theme.links, ";\n\t\t");
});
var Wrapper = styled(ButtonCore).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "TextLink__Wrapper",
  componentId: "sc-9hqv98-0"
})(["", " display:inline;vertical-align:baseline;", " ", ""], positionProps, marginProps, textLinkStyles);
export var TextLink = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var as = _ref2.as,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var Component = as || 'a';
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, otherProps, {
    ref: ref,
    forwardedAs: Component
  }));
});
TextLink.displayName = 'TextLink';

// Allow components to re-use simple text link styles
export { textLinkStyles, textLinkProps };
export default TextLink;